import { CHILD_BENEFIT_TYPES } from 'cpool-constants';
import { z } from 'zod';

import { schemaBigDecimal } from '../../../utils/schema.utils';

/*
	https://docs.api.europace.de/privatkredit/vorgaenge/kex-vorgang-update-api/#kind

	{
        "antragstellerIds": [ String ],
        "kindergeldFuer": "ERSTES_ODER_ZWEITES_KIND" | "DRITTES_KIND" | "AB_VIERTEM_KIND",
        "name": String,
        "unterhaltseinnahmenMonatlich": BigDecimal
    }

*/

export const schemaEuropaceUpdateKind = z.object({
    antragstellerIds: z.array(z.string().min(1)).min(1).max(2),
    kindergeldFuer: z.optional(z.nativeEnum(CHILD_BENEFIT_TYPES)),
    name: z.optional(z.string()), // currently missing in cpool-backend
    unterhaltseinnahmenMonatlich: z.optional(schemaBigDecimal),
});

export type SchemaEuropaceUpdateKind = z.infer<typeof schemaEuropaceUpdateKind>;
